import React from "react";

const Hero = () => {
  return (
    <section className="min-h-screen flex items-center justify-start overflow-hidden px-10 py-16">
      {/* Removed mx-auto and kept a max-w for optional bounding */}
      <div className="max-w-[900px] w-full">
        <div className="space-y-6 text-left">
          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
            <span className="text-yellow-500">Испытайте</span> настоящую
            <br />
            фитнес-революцию.
          </h1>

          <p className="text-base md:text-lg text-white mb-6 max-w-[600px]">
            Раскройте свой потенциал в нашем современном центре, оснащенном
            первоклассным оборудованием и опытными тренерами. Присоединяйтесь к
            нам на пути к тому, чтобы стать сильнее и здоровее. Начните сегодня!
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button className="text-yellow-500 border border-yellow-500 px-4 py-2 sm:px-6 sm:py-2 rounded-lg font-semibold hover:bg-yellow-500 hover:text-white transition-colors w-full sm:w-auto text-center">
              Купить абонемент
            </button>

            <button className="text-yellow-500 border border-yellow-500 px-4 py-2 sm:px-6 sm:py-2 rounded-lg font-semibold hover:bg-yellow-500 hover:text-white transition-colors w-full sm:w-auto text-center">
              Связаться с нами
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
